module.exports = __webpack_public_path__ + "img/time.18e49e53.svg";